import React from "react";
import {FaEdit, FaEye, FaPlus, FaTrash} from "react-icons/fa";

function RoleTable({ roles, onEdit, onDelete, onViewPermissions, onAddPermission }) {
    return (
        <table className="app-table">
            <thead>
            <tr>
                <th>Id</th>
                <th>Name</th>
                <th>Edit</th>
                <th>Delete</th>
                <th>View Permissions</th>
                <th>Add Permission</th>
            </tr>
            </thead>
            <tbody>
            {roles.map(role => (
                <RoleRow role={role} key={role.id} onEdit={onEdit} onDelete={onDelete} onViewPermissions={onViewPermissions} onAddPermission={onAddPermission} />
            ))}
            </tbody>
        </table>
    );
}

function RoleRow({ role, onEdit, onDelete, onViewPermissions, onAddPermission }) {
    return (
        <tr>
            <td>{role.id}</td>
            <td>{role.name}</td>
            <td>
                <FaEdit className="edit-icon" onClick={() => onEdit(role)}/>
            </td>
            <td>
                <FaTrash className="delete-icon" onClick={() => onDelete(role.id)}/>
            </td>
            <td>
                <FaEye className="view-icon" onClick={() => onViewPermissions(role)}/>
            </td>
            <td>
                <FaPlus className="add-icon" onClick={() => onAddPermission(role)}/>
            </td>
        </tr>
    );
}

export default RoleTable;
